import React, { useEffect } from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theming/Theming';
import { useQuery } from 'react-apollo';
import productsQuery from './productsQuery.gql';
import Image from '@jetshop/ui/Image';
import ProductLink from '@jetshop/ui/ProductLink';
import { ScrollBox } from '../../ui/ScrollBox';
import { imageOverlay } from '../../ui/General';

const ListWrapper = styled.div`
  padding: 2rem 0;
  > header {
    padding: 1rem;
  }
  ${theme.above.lg} {
    display: flex;
    > header {
      width: 19%;
      display: flex;
      margin-right: 1%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 5px;
      position: relative;
    }
    > div {
      width: 80%;
    }
  }

  .title {
  }

  .item > a {
    display: block;
    ${imageOverlay}
  }

  //SLIDER WIDTH
  .slider-items {
    .item {
      margin-right: 2%;
      ${theme.only.sm} {
        width: 27%;
        margin-right: 4%;
      }
      ${theme.only.md} {
        width: 21%;
        margin-right: 3%;
      }
      ${theme.only.lg} {
        width: 16%;
      }
      ${theme.above.xl} {
        width: 12%;
      }
    }
  }
`;

const LatestProductsComponent = ({ product, title, list }) => {
  //FETCH LIST
  const result = useQuery(productsQuery, {
    variables: {
      articleNumbers: list,
      errorPolicy: 'ignore',
    },
  });

  const products = result.data?.products;

  useEffect(() => {
    if (product.articleNumber && list[0] !== product.articleNumber) {
      localStorage.setItem(
        'latestProducts',
        JSON.stringify([
          product.articleNumber,
          ...list.filter((item) => item !== product.articleNumber),
        ])
      );
    }
  });

  if (products?.length > 0) {
    const showProducts = products.filter(
      (item) => item.articleNumber !== product.articleNumber
    );
    return (
      <ListWrapper>
        {title && (
          <header>
            <h3 className="title">{title}</h3>
          </header>
        )}
        <div className="product-list">
          <ScrollBox>
            {showProducts.map((prod, index) => {
              const image = prod.images && prod.images[0];
              return (
                <div className="item" key={index}>
                  <ProductLink product={prod}>
                    <Image
                      src={image?.url}
                      alt={image?.alt}
                      sizes={[200]}
                      aspect={theme.productGrid.product.imageAspect}
                      modifiedDate={image?.modifiedDate}
                    />
                  </ProductLink>
                </div>
              );
            })}
          </ScrollBox>
        </div>
      </ListWrapper>
    );
  }
  return null;
};

export const LatestProducts = ({ product, title }) => {
  const client = typeof window !== 'undefined';
  const saved = client && localStorage.getItem('latestProducts');
  const list = saved ? JSON.parse(saved) : [];
  if (client) return <LatestProductsComponent {...{ product, title, list }} />;

  return null;
};
